import { useState } from "react";
import Input from "antd/es/input";
import Button from "antd/es/button";
import Popover from "antd/es/popover";
import Tooltip from "antd/es/tooltip";
import Modal from "antd/es/modal";
import Image from "antd/es/image";
import {
  SmileOutlined,
  PaperClipOutlined,
  FileImageOutlined,
  PlayCircleOutlined,
  FileOutlined,
} from "@ant-design/icons";
import Picker from "emoji-picker-react";
import Emitter from "../utils/emitter";
import http from "../utils/http";

function ChatFooter(props) {
  const [value, setValue] = useState("");
  const [openEmoji, setOpenEmoji] = useState(false);
  const [selectedFile, setSelectedFile] = useState(false);
  const [caption, setCaption] = useState("");
  const [visible, setVisible] = useState(false);

  const sendMessage = async (media, text, callback) => {
    props.setLoading(true);
    const postData = {
      roomId: props.room?.name,
      name: props.response?.body?.name
        ? props.response?.body?.name
        : localStorage.getItem("name"),
      message: text || value,
      media: media ? [media] : null,
    };

    http
      .post(
        `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_TENANT}/replyChat`,
        postData
      )
      .then((res) => {
        if (res) {
          props.setLoading(false);
          Emitter.emit("MESSAGE_SET", res.data);
          setValue("");
          setSelectedFile(false);
          setCaption("");
        }
      })
      .catch(() => {
        props.setLoading(false);
      });
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleEmojiClick = (data) => {
    if (value === "") {
      setValue(data.emoji);
    } else {
      setValue(`${value} ${data.emoji}`);
    }
  };

  const handleUploadClick = (type) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept =
      type === "image"
        ? props.current?.channel === "instagram"
          ? "image/jpeg"
          : "image/*"
        : type === "video"
        ? "video/*"
        : "*";
    input.onchange = (e) => {
      const file = e.target.files[0];
      const fd = new FormData();

      fd.append("folder", "videocall");
      fd.append("files", file);
      props.setLoading(true);
      setVisible(false);
      http
        .post(
          `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_TENANT}/storage/upload`,
          fd
        )
        .then(async (res) => {
          if (res) {
            props.setLoading(false);
            setSelectedFile({ type: type, data: res.data?.data[0] });
          }
        });
    };
    input.click();
  };
  return (
    <div
      style={{
        position: "relative",
        zIndex: 1,
        flex: "none",
        order: 3,
        padding: 10,
        display: "flex",
        flexDirection: "column",
        gap: 10,
      }}
    >
      <Input
        style={{
          background: window.THEMES.chatBubbleIn,
          padding: "15px 15px 15px 15px",
        }}
        value={value}
        onChange={handleChange}
        onKeyPress={(e) => {
          if (e.key === "Enter" && !(e.key === "Enter" && e.shiftKey)) {
            e.preventDefault();
            sendMessage();
          }
        }}
        bordered={false}
        placeholder="Ketik suatu pesan..."
        autoSize={{
          minRows: 1,
          maxRows: 6,
        }}
      />
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <Tooltip title="Kirim Emoji">
          <Popover
            content={
              <Picker emojiStyle="google" onEmojiClick={handleEmojiClick} />
            }
            title="Select Emoji"
            trigger="click"
            open={openEmoji}
            onOpenChange={(e) => setOpenEmoji(!!e)}
          >
            <Button
              type="text"
              icon={<SmileOutlined className="footer-icon-color" />}
              style={{ background: window.THEMES.chatBubbleIn }}
            />
          </Popover>
        </Tooltip>

        <Tooltip title="Kirim Lampiran">
          <Popover
            content={
              <div
                className="flex align-center justify-center"
                style={{ gap: 10 }}
              >
                <Tooltip title="Gambar">
                  <Button
                    style={{ background: "#f1f5f8" }}
                    type="text"
                    icon={<FileImageOutlined />}
                    onClick={() => handleUploadClick("image")}
                  />
                </Tooltip>
                <Tooltip title="Video">
                  <Button
                    style={{ background: "#f1f5f8" }}
                    type="text"
                    icon={<PlayCircleOutlined />}
                    onClick={() => handleUploadClick("video")}
                  />
                </Tooltip>
                <Tooltip title="File">
                  <Button
                    style={{ background: "#f1f5f8" }}
                    type="text"
                    icon={<FileOutlined />}
                    onClick={() => handleUploadClick("document")}
                  />
                </Tooltip>
              </div>
            }
            open={visible}
            title="Upload Disini"
            trigger="click"
          >
            <Button
              style={{ background: window.THEMES.chatBubbleIn }}
              type="text"
              icon={<PaperClipOutlined className="footer-icon-color" />}
              onClick={() => setVisible(!visible)}
            />
          </Popover>
        </Tooltip>
        <div style={{ marginLeft: "auto" }}>
          <Button
            style={{
              background: window.THEMES.chatBubbleIn,
            }}
            type="text"
            onClick={() => sendMessage()}
            className="footer-icon-color"
          >
            Kirim
          </Button>
        </div>
      </div>
      <Modal
        bodyStyle={{ background: window.THEMES.chatRoom }}
        centered
        open={selectedFile}
        title={"Kirim dengan caption"}
        onCancel={async () => {
          await setSelectedFile(false);
        }}
        footer={null}
      >
        {selectedFile?.type === "image" ? (
          <Image
            width={"100%"}
            src={selectedFile?.data?.url}
            style={{
              width: "100%",
              height: "200px",
              objectFit: "contain",
              marginBottom: 10,
              marginTop: 10,
            }}
            alt="Image"
          />
        ) : selectedFile?.type === "video" ? (
          <video
            width="100%"
            height="200px"
            controls
            style={{ marginBottom: 10, marginTop: 10 }}
          >
            <source
              src={selectedFile?.data?.url}
              type={selectedFile?.data?.mimeType}
            />
            Your browser does not support HTML5 video.
          </video>
        ) : (
          <Button
            style={{
              marginTop: 10,
              marginBottom: 10,
              background: window.THEMES.chatBubbleIn,
              color: window.THEMES.buttonTextColor,
              wordBreak: "break-all",
            }}
            type="text"
            icon={<PaperClipOutlined />}
            onClick={() => {
              window.open(selectedFile?.data?.url, "_blank");
            }}
          >
            {selectedFile?.data?.fileName}
          </Button>
        )}
        <Input.TextArea
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
          style={{
            background: window.THEMES.chatBubbleIn,
            marginTop: 10,
            padding: "15px 15px 15px 15px",
          }}
          bordered={false}
          placeholder="Ketik suatu pesan..."
          autoSize={{ minRows: 2, maxRows: 5 }}
        />
        <div style={{ marginTop: 10 }}>
          <Button
            style={{
              background: window.THEMES.chatBubbleIn,
            }}
            type="text"
            className="footer-icon-color"
            onClick={() => {
              sendMessage(selectedFile?.data, caption);
            }}
            disabled={props.loading}
          >
            {props.loading ? "Mohon tunggu..." : "Kirim"}
          </Button>
        </div>
      </Modal>
    </div>
  );
}
export default ChatFooter;
